import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { MenuItem } from '../interfaces/menu-item';
import { MockMenuService } from './mock-menu.service';
import * as Query from '../global-query';
import { AppsyncService } from './appsync.service';
import { Apollo } from 'apollo-angular';
import listMenu from '../graphql/queries/listMenu';
import { LoaderService } from '../pages/loader/loader.service';
import { ItonicsAuthService } from './itonicsAuth.service';

@Injectable()
export class MenuItemsService extends MockMenuService {
  private _menuItems: MenuItem[] = [];

  constructor(
    public apollo: Apollo,
    public appsync: AppsyncService,
    public itonicsAuthService: ItonicsAuthService,
    public loaderService: LoaderService
  ) {
    super(apollo, appsync, itonicsAuthService, loaderService);

    /*this.getItems(listMenu).subscribe(menuItems => {
            this._menuItems = menuItems['data']['listMenu'];
        });*/
  }

  /*  get menuItems(): MenuItem[] {
          return this._menuItems;
      }*/

  updateMenuItems(menuItem: MenuItem): Observable<any> {
    return Observable.create((observer) => {
      const query = menuItem.id ? Query.updateMenu : Query.addMenu;

      console.log('Adding Item Begin !!');

      this.addEditItem(menuItem, query).subscribe(
        (result) => {
          /*const oldItem = this._menuItems.find(h => h.id === res.id);

                if (oldItem) {
                    const updateItem = this._menuItems.find(Utility.findIndexToUpdate, res.id);
                    const index = this._menuItems.indexOf(updateItem);
                    this._menuItems[index] = res;
                }
                else {
                    this._menuItems.push(Object.assign({}, res));
                }*/
          this.onEnd();

          observer.next();
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }

  deleteMenuItems(id: number): Observable<any> {
    return Observable.create((observer) => {
      this.deleteItem(id, Query.deleteMenu).subscribe(
        (res) => {
          /*let index = this._menuItems.map(function (x) {
                    return x.id;
                }).indexOf(id);

                this._menuItems.splice(index, 1);*/
          const result: any = res['data'];
          observer.next(result.deleteMenuItem);
          this.onEnd();
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }

  getMenuById(id: any): Observable<MenuItem> {
    console.log('Content Id is:', id);
    return Observable.create((observer) => {
      this.getItemById(id, Query.getMenuById).subscribe((res) => {
        const result: any = res['data'];
        observer.next(result.menuItem);
        observer.complete();
      });
    });
  }

  getOrderNamebyId(id: any): Observable<MenuItem> {
    return Observable.create((observer) => {
      this.getItems(listMenu).subscribe((menuItems) => {
        observer.next(
          menuItems['data']['listMenu'].find((item) => {
            return item.id === id;
          })
        );
      });
    });
  }

  search_item(term) {
    return Observable.create((observer) => {
      this.searchItemList(term, Query.searchItem).subscribe(
        (itemList) => {
          observer.next(itemList['data']['searchItem']);
          this.onEnd();
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/menu-items.service.ts